/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding } from './FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding';
import {
    FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSON,
    FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSONTyped,
    FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSON,
    FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSONTyped,
} from './FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding';

/**
 * Настройки публичного веб-портала
 * @export
 * @interface FxIdDomainSettingsPortalPublicWebConfigOptions
 */
export interface FxIdDomainSettingsPortalPublicWebConfigOptions {
    /**
     * 
     * @type {FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding}
     * @memberof FxIdDomainSettingsPortalPublicWebConfigOptions
     */
    CompanyBranding: FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding;
}

/**
 * Check if a given object implements the FxIdDomainSettingsPortalPublicWebConfigOptions interface.
 */
export function instanceOfFxIdDomainSettingsPortalPublicWebConfigOptions(value: object): value is FxIdDomainSettingsPortalPublicWebConfigOptions {
    if (!('CompanyBranding' in value) || value['CompanyBranding'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSON(json: any): FxIdDomainSettingsPortalPublicWebConfigOptions {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPortalPublicWebConfigOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'CompanyBranding': FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSON(json['CompanyBranding']),
    };
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsToJSON(json: any): FxIdDomainSettingsPortalPublicWebConfigOptions {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsPortalPublicWebConfigOptionsToJSONTyped(value?: FxIdDomainSettingsPortalPublicWebConfigOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'CompanyBranding': FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSON(value['CompanyBranding']),
    };
}

